import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss'],
})
export class FaqSectionComponent implements OnInit {
  faqs: { question: string; answer: string }[] = [];

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.http
      .get('assets/wheretaken-classic-faq.md', { responseType: 'text' })
      .subscribe((data) => {
        this.faqs = this.parseMarkdownToFaqs(data);
      });
  }

  parseMarkdownToFaqs(md: string): { question: string; answer: string }[] {
    const sections = md
      .split('##')
      .map((s) => s.trim())
      .filter(Boolean);
    return sections.map((section) => {
      const [questionLine, ...rest] = section.split('\n');
      return {
        question: questionLine.trim(),
        answer: rest.join('\n').trim(),
      };
    });
  }
}
